import { render, staticRenderFns } from "./Logos2.vue?vue&type=template&id=0b9a500c&scoped=true&"
import script from "./Logos2.vue?vue&type=script&lang=js&"
export * from "./Logos2.vue?vue&type=script&lang=js&"
import style0 from "./Logos2.vue?vue&type=style&index=0&id=0b9a500c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a500c",
  null
  
)

export default component.exports